module.exports = "/static/assets/f4578dc60a4dcd863f939780adcc12eb.png";